module.exports = __webpack_public_path__ + "04.jpg?05376b927a496d39a5ec2a551c685a29";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/04.jpg
// module id = 141
// module chunks = 0